import './HeaderTextWithLine.scss';

import React, { memo } from 'react';

import { Typography } from 'antd';

interface HeaderTitleProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  alignment?: 'left' | 'center' | 'right';
  hideLine?: boolean;
  titleStyle?: React.CSSProperties;
  lineStyle?: React.CSSProperties;
  style?: React.CSSProperties;
}

const HeaderTextWithLine: React.FC<HeaderTitleProps> = ({
  title,
  alignment = 'left',
  hideLine = false,
  className = '',
  titleStyle,
  lineStyle,
  style,
  ...props
}) => {
  return (
    <div
      className={`header-lined align-${alignment} ${className}`}
      style={style}
      {...props}
    >
      {hideLine ? null : (
        <span className="header-lined__line" style={lineStyle} />
      )}

      <Typography.Text
        className="header-lined__title"
        ellipsis={{ tooltip: title }}
        style={titleStyle}
      >
        {title}
      </Typography.Text>

      {hideLine ? null : (
        <span className="header-lined__line" style={lineStyle} />
      )}
    </div>
  );
};

export default memo(HeaderTextWithLine);
